module.exports = __webpack_public_path__ + "img/RUN-HEELSTRIKE-05.42909bd1.png";